import { i18n } from '../../i18n';
import { TAG_TYPE } from '@/constants';
import _ from 'lodash';
import { request } from 'beans-admin-plugin';

export const STORE_STATUSES = [
  'auto',
  'business',
  'rest',
]

export const STORE_KINDS = [
  'flagship_store',
  'store_in_store',
  'dealer',
]


export const filterColumnsHash = {
  address_cont: {
    label: i18n.t('store.address'),
    renderCell: {
      component: 'input'
    }
  },
  email_cont: {
    label: i18n.t('store.email'),
    renderCell: {
      component: 'input'
    }
  },
  name_cont: {
    label: i18n.t('store.name'),
    renderCell: {
      component: 'input'
    }
  },
  phone_cont: {
    label: i18n.t('store.phone'),
    renderCell: {
      component: 'input'
    }
  },
  status_eq: {
    label: i18n.t('store.status'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        options: _.map(STORE_STATUSES, (value) => ({ label: i18n.t(`store.statuses.${value}`), value: value }))
      }
    }
  },
  kind_eq: {
    label: i18n.t('store.kind'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        options: _.map(STORE_KINDS, (value) => ({ label: i18n.t(`store.kinds.${value}`), value: value }))
      }
    }
  },
  country_id_eq: {
    label: i18n.t('store.country'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        xRemotePreload: async () => {
          const { data } = await request.get('/countries', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { name_cont: keyword };
          const { data } = await request.get('/countries', { params });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('store.id'),
    width: 80,
  },
  address: {
    label: i18n.t('store.address'),
  },
  email: {
    label: i18n.t('store.email'),
  },
  name: {
    label: i18n.t('store.name'),
  },
  phone: {
    label: i18n.t('store.phone'),
  },
  latitude: {
    label: i18n.t('store.latitude'),
  },
  longitude: {
    label: i18n.t('store.longitude'),
  },
  country_id: {
    label: i18n.t('store.country'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.country) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'countries.show', params: { id: row.country_id } }}>{row.country.name}</bean-link>
    },
  },
  status: {
    label: i18n.t('store.status'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.status) {
        return <span>/</span>
      }
      return <el-tag type={TAG_TYPE[row.status]}>{i18n.t(`store.statuses.${row.status}`)}</el-tag>;
    },
  },
  kind: {
    label: i18n.t('store.kind'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.kind) {
        return <span>/</span>
      }
      return <el-tag type={TAG_TYPE[row.kind]}>{i18n.t(`store.kinds.${row.kind}`)}</el-tag>;
    },
  },
  created_at: {
    label: i18n.t('store.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('store.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  wxacode: {
    label: i18n.t('store.wxacode'),
    width: 120,
    renderCell: 'storageAttachment',
  },
  images: {
    label: i18n.t('store.images'),
    renderCell: 'storageAttachment',
  },
}

export const formColumnsHash = {
  address: {
    label: i18n.t('store.address'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  email: {
    label: i18n.t('store.email'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  name: {
    label: i18n.t('store.name'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  phone: {
    label: i18n.t('store.phone'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  country_id: {
    label: i18n.t('store.country'),
    renderCell: {
      required: true,
      component: 'select',
      props: {
        xRemotePreload: async () => {
          const { data } = await request.get('/countries', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { name_cont: keyword };
          const { data } = await request.get('/countries', { params });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  },
  status: {
    label: i18n.t('store.status'),
    renderCell: {
      required: true,
      component: 'select',
      props: {
        options: _.map(STORE_STATUSES, (value) => ({ label: i18n.t(`store.statuses.${value}`), value: value }))
      }
    }
  },
  kind: {
    label: i18n.t('store.kind'),
    renderCell: {
      required: true,
      component: 'select',
      props: {
        options: _.map(STORE_KINDS, (value) => ({ label: i18n.t(`store.kinds.${value}`), value: value }))
      }
    }
  },
  latitude: {
    label: i18n.t('store.latitude'),
    renderCell: {
      required: true,
      component: 'inputNumber',
    },
  },
  longitude: {
    label: i18n.t('store.longitude'),
    renderCell: {
      required: true,
      component: 'inputNumber',
    },
  },
  images: {
    label: i18n.t('store.images'),
    renderCell: {
      required: true,
      component: 'upload',
    }
  },
}
